fx.translations("es", {
   
    "Sauvegarde de votre mise en page ..." : "Guardando el diseño...",

    "Les photos HEIC doivent être totalement téléchargées pour être utilisées pour la création automatique." : "Las imágenes HEIC no pueden utilizarse para la creación automática."
});

